import React, { useRef, useState } from 'react';

function EntryItem ({ entry, onClick }) {
  const TOP_ABOVE_WINDOW = -1000; // 레이어의 기본 Top 값으로 레이어가 위도우 밖으로 표시되도록 함 (=표시되지 않도록)
  const TOP_OFFSET = 32;
  const [layerInfoTop, setLayerInfoTop] = useState(TOP_ABOVE_WINDOW);
  const elTitle = useRef(null);
  const layerInfoStyle = {
    top: `${layerInfoTop}px`,
    left: '50%',
    marginLeft: '-150px',
  };

  function onClickEntry (e) {
    e.preventDefault();
    onClick(entry);
  }

  function onMouseOver () {
    if (!elTitle.current) {
      return;
    }
    const newTop = elTitle.current.getBoundingClientRect().y + TOP_OFFSET;
    setLayerInfoTop(newTop);
  }

  function onMouseLeave () {
    setLayerInfoTop(TOP_ABOVE_WINDOW);
  }

  return (
    <li onClick={onClickEntry} onMouseOver={onMouseOver} onMouseLeave={onMouseLeave}>
      <span className="txt_date">{entry.created}</span>
      <span className="txt_cate">{entry.label}</span>
      <span className="txt_info" ref={elTitle}>
        <a href={entry.url} className="link_info" >{entry.title}</a>
        <div className="layer_info" style={layerInfoStyle}>
          <div className="inner_layer">{entry.summary}</div>
        </div>
      </span>
    </li>
  );
}

export default EntryItem;
